import store from "./index";

export const checkPermissionsFor = (method) => {
    const permissionMethods = store.getState().auth.permissions;
    return permissionMethods?.length ? permissionMethods.includes(method) : false;
};

